import React from "react";
import { Input } from "../../../../library/form";

const FundSettings = function ({ settings, onChangeCrudObject }) {
    return (
        <div>
            <Input
                label="Skill Development Fund Per Quarter"
                name="skillDevelopmentFund"
                type="number"
                value={settings["skillDevelopmentFund"]}
                onChange={onChangeCrudObject}
                placeholder="Skill Development Fund"
            />
        </div>
    );
};

export default FundSettings;